import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';

declare global {
  interface Window { _paq: any[]; }
}
declare let window: Window;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (window._paq) {
          window._paq.push(['setDocumentTitle', document.title]);
          window._paq.push(['setCustomUrl', event.urlAfterRedirects]);
          window._paq.push(['trackPageView']);
        }
      }
    });
  }
}
